export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bonus.vue?vue&type=template&id=18cf28b9"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/bonus/bonus.vue?vue&type=template&id=18cf28b9
// module id = FUtV
// module chunks = 0